import { render, staticRenderFns } from "./AccountActivation.vue?vue&type=template&id=6bc166dc&scoped=true"
import script from "./AccountActivation.vue?vue&type=script&lang=js"
export * from "./AccountActivation.vue?vue&type=script&lang=js"
import style0 from "./AccountActivation.vue?vue&type=style&index=0&id=6bc166dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc166dc",
  null
  
)

export default component.exports